import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * A consistent "nothing here yet" placeholder — drop in wherever a list/table
 * would otherwise render bare text like "No data". Works standalone or inside
 * a <TableCell colSpan={N}>.
 */
const EmptyState = ({ icon, title = 'Nothing here yet', description, action, compact = false }) => (
  <Box
    sx={{
      textAlign: 'center',
      py: compact ? 3 : 6,
      px: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0.5,
    }}
  >
    <Box sx={{ color: 'text.disabled', mb: 1 }}>
      {icon || <InboxOutlinedIcon sx={{ fontSize: compact ? 32 : 44 }} />}
    </Box>
    <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.secondary' }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ color: 'text.disabled', maxWidth: 360 }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 1.5 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
